import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  AutomaticResendsService,
  OutBoxMessagesService,
} from 'src/app/core/api/services';
import {
  AutomaticResendsWithPaginationDto,
  CustomResultOfPaginatedListOfAutomaticResendsWithPaginationDto,
  PaginatedListOfAutomaticResendsWithPaginationDto,
} from '../../../core/api/models';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { GetEnumValuesDto } from './../../../core/api/models/get-enum-values-dto';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { AutomaticResendFormComponent } from "./automatic-resend-form/automatic-resend-form.component";



@Component({
    selector: 'app-automatic-resend',
    templateUrl: './automatic-resend.component.html',
    imports: [BaseIndexModule, AutomaticResendFormComponent]
})
export class AutomaticResendComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.automaticResend;

  /* Binding service endpoints */
  protected currentService = inject(AutomaticResendsService);
  paginationApiMethodName: string = this.currentService.automaticResendsGetAutomaticResendsWithPagination.name;
  createGetApiMethodName: string = this.currentService.automaticResendsCreateGet.name;
  deleteApiMethodName: string = this.currentService.automaticResendsDelete.name;
  auditApiMethodName: string = this.currentService.automaticResendsGetAutomaticResendsAudit.name;
  /* Binding service endpoints */




  modelWithPagination$: Observable<PaginatedListOfAutomaticResendsWithPaginationDto>;
  items$: Observable<Array<AutomaticResendsWithPaginationDto>>;
  formPageConfig: FormPageConfig<any> = {};

  //enums
  TypeDeliveryStatusEnumValues: GetEnumValuesDto[] = [];

  //#endregion

  constructor(
    public outBoxMessagesService: OutBoxMessagesService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  getEnumsValues() {
    this.getEnumValuesApi('DeliveryStatus')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.TypeDeliveryStatusEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: this.localizer.organizationName,
        name: 'organizationName',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}privateNumber`,
        name: 'privateNumber',
        hasSearch: true,
        dir: 'ltr',
      },
      {
        title: `${this.tableVocabs}deliveryStatus`,
        name: 'deliveryStatus',
        hasSearch: true,
        type: 'enum',
        enumName: 'DeliveryStatus',
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  //Get ById
  baseGetByIdApi(id: number): void {
    // this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .automaticResendsUpdateGet({ Id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  //#endregion
}
